import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { BillingIntervalEnum, PlanEnum } from 'enums';
import { COLOR_GRAY_20, COLOR_GRAY_70, COLOR_GRAY_90 } from 'styles/variables/colors';
import { Icons } from 'components/Icons';
import TeamSizeSelect from 'components/PricingContent/TeamsPlans/TeamSizeSelect';
import { useCheckoutContext } from 'contexts/CheckoutContext';

export const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(2),
  },
  billingCycleContainer: {
    fontFamily: 'Lato',

    '& h4': {
      color: COLOR_GRAY_90,
      fontSize: 18,
      fontWeight: 700,
      lineHeight: '120%',
    },

    '& .active': {
      border: `1px solid #7F56D9`,
      backgroundColor: '#F9F5FF',
    },

    '& .active h6': {
      color: '#53389E',
    },

    '& .active .time': {
      backgroundColor: '#F9F5FF',
    },
  },
  billingCycleCard: {
    borderRadius: '12px',
    border: `1px solid ${COLOR_GRAY_20}`,
    maxWidth: 422,
    cursor: 'pointer',

    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  time: {
    borderRadius: 12,

    '& h6': {
      color: COLOR_GRAY_70,
      fontSize: 16,
      fontWeight: 700,
      lineHeight: '120%',
      margin: 0,
    },

    '& > div': {
      padding: '16px 20px 16px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  saveDiscount: {
    padding: '2px 6px',
    borderRadius: 6,
    border: '1px solid #ABEFC6',
    backgroundColor: '#ECFDF3',
    color: '#067647',
    lineHeight: '17px',
    fontSize: 12,
  },
}));

const options = [
  { id: 'year', label: 'Annual Plan', billingInterval: BillingIntervalEnum.YEAR },
  { id: 'month', label: 'Monthly Plan', billingInterval: BillingIntervalEnum.MONTH },
];

export default function BillingCycle() {
  const classes = useStyles();
  const {
    data: { billingInterval, planData, coupon, teamSize },
    actions: { setBillingInterval, setTeamSize },
  } = useCheckoutContext();

  const hasCoupon = !!coupon?.percent;
  const savingsPercentage = planData[BillingIntervalEnum.YEAR].savingsPercentageDisplay;
  const plan = planData[BillingIntervalEnum.YEAR].id;

  return (
    <Box mt={3} pb={3} className={classes.billingCycleContainer}>
      <Typography variant="h4" className={classes.title}>
        Billing cycle
      </Typography>

      {plan === PlanEnum.LAB_RESEARCHER && (
        <Box mb={2}>
          <TeamSizeSelect
            options={[
              { id: '5', value: 5 },
              { id: '10', value: 10 },
              { id: '15', value: 15 },
              { id: '20', value: 20 },
              { id: '25', value: 25 },
            ]}
            teamSize={teamSize}
            onChange={setTeamSize}
            condensed
          />
        </Box>
      )}

      {options.map((option, index) => {
        const isActive = billingInterval === option.billingInterval;

        return (
          <Box
            key={option.id}
            className={
              isActive ? `${classes.billingCycleCard} active` : `${classes.billingCycleCard}`
            }
            marginBottom={index === options.length - 1 ? 0 : 1}
            onClick={() => setBillingInterval(option.billingInterval)}
            id={option.id}
          >
            <Box className={classes.time}>
              <div>
                <h6>{option.label}</h6>

                <Box display="flex" justifyContent="center" alignItems="center">
                  {!hasCoupon && option.billingInterval === BillingIntervalEnum.YEAR && (
                    <Box className={classes.saveDiscount}>Save up to {savingsPercentage}</Box>
                  )}

                  {isActive ? (
                    <Icons.checkCircle style={{ color: '#7F56D9', height: 17 }} />
                  ) : (
                    <Icons.radioButtonUnchecked style={{ color: '#C6CEDD', height: 17 }} />
                  )}
                </Box>
              </div>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
